import {
  assetSubsystemMappingsApi,
  assetSubsystemComponentClassMappingsApi,
  assetSubsystemComponentClassComponentTypeMappingsApi,
} from '~/app/services/knowledgeBase/api-instances';

export async function setComponentClassesForSubsystem(
  subsystemId: string,
  componentClassIds: string[],
): Promise<void> {
  // No-op since API is not available
  console.log('setComponentClassesForSubsystem called with:', {
    subsystemId,
    componentClassIds,
  });
}

export async function setSubsystemsForComponentClass(
  componentClassId: string,
  subsystemIds: string[],
): Promise<void> {
  // No-op since API is not available
  console.log('setSubsystemsForComponentClass called with:', {
    componentClassId,
    subsystemIds,
  });
}

export async function setSubsystemsForAssetType(
  assetTypeId: string,
  subsystemIds: string[],
): Promise<void> {
  await assetSubsystemMappingsApi.assetSubsystemMappingControllerSetSubsystemsForAssetType(
    {
      assetTypeId,
      setSubsystemsForAssetTypeRequestDto: { assetTypeId, subsystemIds },
    },
  );
}

export async function getSubsystemIdsForAssetType(
  assetTypeId: string,
): Promise<string[]> {
  const mappings =
    await assetSubsystemMappingsApi.assetSubsystemMappingControllerGetSubsystemsForAssetType(
      { assetTypeId },
    );
  return mappings.map((m) => m.subsystemId);
}

export async function getAssetTypeIdsForSubsystem(
  subsystemId: string,
): Promise<string[]> {
  const mappings =
    await assetSubsystemMappingsApi.assetSubsystemMappingControllerGetAssetTypesForSubsystem(
      { subsystemId },
    );
  return mappings.map((m) => m.assetTypeId);
}

export async function setAssetTypesForSubsystem(
  subsystemId: string,
  assetTypeIds: string[],
): Promise<void> {
  await assetSubsystemMappingsApi.assetSubsystemMappingControllerSetAssetTypesForSubsystem(
    {
      subsystemId,
      setAssetTypesForSubsystemRequestDto: { subsystemId, assetTypeIds },
    },
  );
}

export async function setComponentClassesForJunction(
  _junctionId: string,
  componentClassIds: string[],
): Promise<string[]> {
  return componentClassIds;
}

export async function setComponentClassesForAssetSubsystemMapping(
  mappingId: string,
  componentClassIds: string[],
): Promise<void> {
  await assetSubsystemComponentClassMappingsApi.assetSubsystemComponentClassControllerUpdateMapping(
    {
      mappingId,
      createAssetTypeSubsystemComponentClassRequestDto: {
        associatedComponentClassIds: componentClassIds,
      },
    },
  );
}

export async function getComponentTypesForAssetSubsystemComponentClassMapping(
  mappingId: string,
): Promise<string[]> {
  const detail =
    await assetSubsystemComponentClassComponentTypeMappingsApi.assetSubsystemComponentClassComponentTypeControllerFindById(
      { id: mappingId },
    );
  return detail.associatedComponentTypeIds ?? [];
}

export async function setComponentTypesForAssetSubsystemComponentClassMapping(
  mappingId: string,
  componentTypesIds: string[],
): Promise<void> {
  await assetSubsystemComponentClassComponentTypeMappingsApi.assetSubsystemComponentClassComponentTypeControllerUpdateMapping(
    {
      mappingId,
      createAssetTypeSubsystemComponentClassComponentTypeRequestDto: {
        associatedComponentTypeIds: componentTypesIds,
      },
    },
  );
}
